import { render, staticRenderFns } from "./quesOne.vue?vue&type=template&id=131a89f0"
import script from "./quesOne.vue?vue&type=script&lang=js"
export * from "./quesOne.vue?vue&type=script&lang=js"
import style0 from "./quesOne.vue?vue&type=style&index=0&id=131a89f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports